import { useCallback, useState } from 'react';

import { NullableDate } from '~components/Filters/DateRangePicker';

interface DeletedRecordsDateRange {
  endDate: NullableDate;
  startDate: NullableDate;
}

const EMPTY_DATE_RANGE: DeletedRecordsDateRange = { endDate: null, startDate: null };

// DateRangePicker's onDateSelect fires on every day click, so the fetch waits for close.
export default function useDeletedRecordsDateFilter() {
  const [appliedRange, setAppliedRange] =
    useState<DeletedRecordsDateRange>(EMPTY_DATE_RANGE);
  const [draftRange, setDraftRange] = useState<DeletedRecordsDateRange>(EMPTY_DATE_RANGE);

  const selectRange = useCallback(
    (startDate: NullableDate, endDate: NullableDate) =>
      setDraftRange({ endDate, startDate }),
    [],
  );

  const applyRange = useCallback(() => setAppliedRange(draftRange), [draftRange]);

  return { appliedRange, applyRange, draftRange, selectRange };
}
